import React, { Component, type JSX } from 'react';

interface ComponentProps {
  error: string;
}

interface ComponentState {}

export class SearchValidationError extends Component<ComponentProps, ComponentState> {
  public render(): JSX.Element {
    const { error } = this.props;

    return (
      <div className="search-filter__validation-error">
        <i className="fa fa-warning"/>{error}
      </div>
    );
  }
}
